import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import StackBar from "../../../../../Component/Charts/StackBar";
import config from "../config";

const { chartColors } = config;

const CheckAvgTimeByStatus = (props) => {
  const { data = [] } = props;
  const { t } = useTranslation();

  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    data.forEach(item => {
      item.avg_time = Math.round((item.avg_time / 60) * 100) / 100
    });
    const kyc = data.filter((s) => s.check_type === "KYC");
    const kycInProgress = kyc.find((s) => s.state === "Under Review");
    const kycInProgressCount = kycInProgress ? kycInProgress.avg_time : 0;
    const kycInApproval = kyc.find((s) => s.state === "Approved");
    const kycInApprovalCount = kycInApproval ? kycInApproval.avg_time : 0;
    const aml = data.filter((s) => s.check_type === "AML");
    const amlInProgress = aml.find((s) => s.state === "Under Review");
    const amlInProgressCount = amlInProgress ? amlInProgress.avg_time : 0;
    const amlInApproval = aml.find((s) => s.state === "Approved");
    const amlInApprovalCount = amlInApproval ? amlInApproval.avg_time : 0;
    setSeries([
      {
        name: t("labels.dashboard.checkAvgTimeByStatus.inProgress"),
        data: [kycInProgressCount, amlInProgressCount],
        color: chartColors["stateColors"]["inProgress"],
        labelFormatter: (params) => params.data === 0 ? '' : `${params.data} Hours`,
        labelPosition: "insideRight"
      },
      {
        name: t("labels.dashboard.checkAvgTimeByStatus.inApproval"),
        data: [kycInApprovalCount, amlInApprovalCount],
        color: chartColors["stateColors"]["inApproval"],
        labelFormatter: (params) => params.data === 0 ? '' : `${params.data} Hours`,
        labelPosition: "insideRight"
      },
    ]);
    setCategories(["KYC", "AML"]);
  }, [data]);

  return (
    <StackBar
      title={t("labels.dashboard.checkAvgTimeByStatus.title")}
      series={series}
      categories={categories}
    />
  );
};

export default CheckAvgTimeByStatus;
